import { createClient, SupabaseClient } from "@supabase/supabase-js";

// Load environment variables
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error("Supabase environment variables are not defined");
}

// A hot module reload must reuse the browser's existing session manager. Creating
// another GoTrue client for the same storage key can leave competing auth locks.
const browser =
  typeof window === "undefined"
    ? undefined
    : (window as Window & {
        __snowsProAmSupabase?: {
          url: string;
          key: string;
          client: SupabaseClient;
        };
      });
const cached = browser?.__snowsProAmSupabase;
export const supabase =
  cached?.url === SUPABASE_URL && cached?.key === SUPABASE_ANON_KEY
    ? cached.client
    : createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
        auth: {
          storage: localStorage,
          autoRefreshToken: true,
          persistSession: true,
          detectSessionInUrl: true, // usually true for web unless using custom routing
        },
      });
if (browser)
  browser.__snowsProAmSupabase = {
    url: SUPABASE_URL,
    key: SUPABASE_ANON_KEY,
    client: supabase,
  };
